import Tooltip from "common/Tooltips/Tooltip";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import ActionButton from "common/Buttons/ActionButton";
import { CSSProperties } from "react";
import { useTheme } from "styled-components";
import { useBottomNavigator } from "utils/hooks/misc.tsx";

interface BuyButtonProps {
  onClick: () => void;
  className?: string;
  hoverTitle?: string;
  style?: CSSProperties;
  isLoading?: boolean;
  /**
   * New look, phone: the floating button is hidden (it covers row content and
   * duplicates the header's "+"); pages whose action has no other entry keep
   * it with this flag.
   */
  keepOnNewLookPhone?: boolean;
}

const BuyButton = ({
  onClick,
  className,
  hoverTitle,
  style,
  isLoading,
  keepOnNewLookPhone,
}: BuyButtonProps) => {
  const { isNewLook } = useTheme();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  if (isNewLook && isBottomNavigator && !keepOnNewLookPhone) return null;
  return (
    <Tooltip title={hoverTitle}>
      <ActionButton
        onClick={onClick}
        icon={<PlusOutlined />}
        className={className}
        style={style}
        loading={isLoading}
      />
    </Tooltip>
  );
};

export default BuyButton;
